import {Entity} from "../Entity";

export class Tenant implements Entity {
    id: string;
    name: string;

    constructor(id: string, name: string) {
        this.id = id;
        this.name = name;
    }
}
